// extracted by mini-css-extract-plugin
export default {"text":"styles_text__dXHYD","text--description":"styles_text--description__JnS3Q"};